// extracted by mini-css-extract-plugin
module.exports = {"cardPaddingsOverwrite":"WebsiteContent__cardPaddingsOverwrite___627Oc"};